import { render, staticRenderFns } from "./NoResultsPlaceholder.vue?vue&type=template&id=b8ebef98&scoped=true"
var script = {}
import style0 from "./NoResultsPlaceholder.vue?vue&type=style&index=0&id=b8ebef98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ebef98",
  null
  
)

export default component.exports